import pubsub from 'pubsub-js';
import gaTracker from './ga-tracker';
import productData from './product-data';
import slider from 'bootstrap-slider';

let config = {
		sliderSelector: '.Slider',
		sliderValueSelector: '.js-slider-value'
	},
	sliderElms = [];

var $planEl,
	$durationEl;

function updateSliderValue(e, data) {
	
	let inputValue = productData.value[data.id][data.value],
		plan = productData.value['plan'][$planEl.val()],
		duration = productData.value['duration'][$durationEl.val()],
		sku = productData.sku[plan][duration],
		price = productData.price[plan]['total'][duration];

	// Find slider value element from the given slider element
	// Used jquery for easy DOM travel
	$(data.elm).closest(config.sliderSelector)
		.find(config.sliderValueSelector)
		.html(inputValue);
	
	if (data.id == 'plan') {
		gaTracker.track('Plan|Selection|' + plan + 'GB');
	} else if (data.id == 'duration') {
		gaTracker.track('Package Duration|Selection|' + duration + 'MO');
	}
	
	gaTracker.trackEcomm('impression|' + sku + '|' + sku + '|' + price + '|Mint Mobile|Plans|' + duration + ' Month|1');
}

// @param {object} item - slider object
function getSliderValue(item) {
	let inputRole = item.getAttribute('id');
	
	return {
		slider: item, // slider itself
		elm: item.getElement(), // slider element,
		id: item.getAttribute('id'),
		value: item.getValue()
	}
}

function init() {

	if(!document.getElementById("js-slider-package") || !document.getElementById("js-slider-data")) {
		return;
	}
	
	$planEl = $('#js-slider-data');
	$durationEl = $('#js-slider-package');

	let sliderDuration = new slider("#js-slider-package", {
		id: 'duration',
		ticks: [0, 1, 2],
		min: 1,
		max: 3,
		ticks_labels: ['3MO', '6MO', '12MO'],
		ticks_snap_bounds: 1,
		tooltip: 'hide'
	});

	// Set 3MO as a init value
	sliderDuration.setValue(0);

	let sliderPlan = new slider("#js-slider-data", {
		id: 'plan',
		ticks: [0, 1, 2],
		min: 1,
		max: 3,
		ticks_labels: ['2GB', '5GB', '10GB'],
		ticks_snap_bounds: 1,
		tooltip: 'hide'
	});

	// Set 2GB as a init value
	sliderPlan.setValue(0);

	sliderElms.push(sliderDuration);
	sliderElms.push(sliderPlan);

	// AddEventListener to each slider
	// https://github.com/seiyria/bootstrap-slider
	sliderElms.forEach((item) => {

		item.on('change', () => {
			pubsub.publish('slider.change', getSliderValue(item));
		});

	});

	pubsub.subscribe('slider.change', updateSliderValue);
}

export default init;